/** @format */

import React, { FC, PropsWithChildren } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../app/hooks";
import FeatureFlag from "../featureFlag/FeatureFlag";
import { selectTheme, setTheme, themeTypes } from "./themeSlice";

const ThemeSwitcher: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();
  const theme = useAppSelector(selectTheme());

  const handleSelectTheme = (ev: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setTheme(ev.target.value as themeTypes));
  };
  return (
    <FeatureFlag flag={["themeswitcher"]}>
      <div className="mx-3 p-1 text-bg-light">
        <label>
          Select a theme &nbsp;
          <select
            data-testid="select_theme"
            onChange={handleSelectTheme}
            value={theme}
          >
            <optgroup label="Legacy">
              <option value="gcse">GCSE</option>
              <option value="alevel">Alevel</option>
            </optgroup>
            <optgroup label="Other">
              <option value="asbwales">ASBW</option>
              <option value="vq">VQ</option>
              <option value="qdo">QDO</option>
              <option value="other">Other</option>
            </optgroup>
            <optgroup label="Made for Wales">
              <option value="mfwGcse">MFW GCSE</option>
              <option value="mfwAlevel">MFW A Level</option>
              <option value="mfwLevel2">MFW Level 2</option>
            </optgroup>
            <optgroup label="Vocational">
              <option value="vqEntryPath">Entry Pathway</option>
              <option value="vqLevel12">VQ Level 1/2</option>
              <option value="vqLevel23">VQ Level 2/3</option>
              <option value="vqLevel3">VQ Level 3</option>
              <option value="multiLevel">Multi Level</option>
            </optgroup>
          </select>
        </label>
      </div>
    </FeatureFlag>
  );
};

export default ThemeSwitcher;
